import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetch } from "services/orders.service";
import { Order } from "types/Order";

interface OrdersState {
  ordersCollection: Order[];
  isLoading: boolean;
  isError: boolean;
  errMsg: string | null;
  queryValue: string | null;
  filtersValue: Record<string, any>;
}

interface SetOrdersPayload {
  ordersCollection: Order[];
}

interface SetErrorPayload {
  errMsg: string;
}

interface SetFilterValuePayload {
  key: string;
  value: any;
}

const initialState: OrdersState = {
  ordersCollection: [],
  isLoading: false,
  isError: false,
  errMsg: null,
  queryValue: null,
  filtersValue: {},
};

const OrdersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setLoading(state) {
      state.isLoading = true;
      state.isError = false;
    },
    setOrders(state, action: PayloadAction<SetOrdersPayload>) {
      state.isLoading = false;
      state.ordersCollection = action.payload.ordersCollection;
    },
    setError(state, action: PayloadAction<SetErrorPayload>) {
      state.isError = true;
      state.errMsg = action.payload.errMsg;
    },
    setFilterValue(state, action: PayloadAction<SetFilterValuePayload>) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
});

export const { setLoading, setOrders, setError, setFilterValue } =
  OrdersSlice.actions;

export default OrdersSlice.reducer;

export const fetchOrders = (filtersValue: any) => async (dispatch: any) => {
  dispatch(setLoading());
  try {
    const { ordersCollection } = await fetch(filtersValue);
    dispatch(setOrders({ ordersCollection }));
  } catch (e) {
    dispatch(setError({ errMsg: "unexpected_error" }));
  }
};
